import { c as _c } from "react/compiler-runtime";
import { useSearchPageMapData } from "@/providers/search";
import { useMap } from "@vis.gl/react-google-maps";
import { Loader2 as LoaderCircleIcon } from "lucide-react";
import React from "react";
import { Marker } from "./marker";
export const Markers = React.memo(function Markers() {
  const $ = _c(5);
  const map = useMap();
  const markers = useSearchPageMapData(_temp);
  const hasFirstClientDataLoaded = useSearchPageMapData(_temp2);
  if (!hasFirstClientDataLoaded) {
    return null;
  }
  if (!map) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="absolute inset-0 flex items-center justify-center bg-white/50 z-10"><LoaderCircleIcon className="w-8 h-8 animate-spin text-primary-500" /><span className="ml-2 text-gray-600">Initializing map...</span></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== markers) {
    t0 = markers.map(_temp3);
    $[1] = markers;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = <>{t0}</>;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
});
function _temp(state) {
  return state.mapData;
}
function _temp2(state_0) {
  return state_0.hasFirstClientDataLoaded;
}
function _temp3(marker) {
  return <Marker key={`marker-${marker._id?.toString()}`} marker={marker} />;
}